import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link as RouterLink } from 'react-router-dom'
import { Box, Button, TextField, Typography } from '@mui/material'
import { useForgotPassword } from '../../hooks/api/auth'
import getSubmissionErrors from '../../utils/submissionErrors'

const ForgotPasswordForm = () => {
  const [submitted, setSubmitted] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
  } = useForm({ criteriaMode: 'all' })

  const { mutateAsync } = useForgotPassword()

  const onSubmit = async (data) => {
    data.email = data.email?.toLowerCase()
    try {
      await mutateAsync(data)
      setSubmitted(true)
    } catch (err) {
      for (const { name, message } of getSubmissionErrors(err)) {
        setError(name, { message })
      }
    }
  }

  if (submitted) {
    return (
      <Box display='flex' flexDirection='column'>
        <Box mb={2}>
          <Typography variant='p'>
            A verification link has been sent to your email account. Please check your email to
            reset your password.
          </Typography>
        </Box>
        <Button variant='contained' component={RouterLink} to='/login'>
          Back to login
        </Button>
      </Box>
    )
  }
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box display='flex' flexDirection='column' rowGap={2} justifyContent='space-between'>
        <TextField
          placeholder='example@example.com'
          label='Email address'
          inputProps={{
            ...register('email', {
              required: 'Email address is required.',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Invalid email address.',
              },
            }),
            autoCapitalize: 'none',
            style: { textTransform: 'lowercase' },
          }}
          error={Boolean(errors?.['email'])}
          helperText={errors?.['email']?.message}
        />

        <Button type='submit' variant='contained' disabled={isSubmitting}>
          Email me a recovery link
        </Button>
      </Box>
    </form>
  )
}

export default ForgotPasswordForm
